import { useContext, useEffect, useState } from "react";
import { MdArrowForward, MdExpandMore } from "react-icons/md";
import { AppContext } from "../App";
import { CDN_URL, getInlineLoader } from "../Helpers";
import fallbackImage from "../assets/banner-removebg-preview.png";
import packageImage from "../assets/piece.png";
import Footer from "../ones/Footer";

const PAGE_SIZE = 10;

export default function ProductsLanding() {
  const appContext = useContext(AppContext);
  const [products, setProducts] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function loadProducts() {
      setLoading(true);
      const result = await appContext.getAllProducts({
        limit: PAGE_SIZE,
        withMeta: true,
      });
      if (mounted) {
        setProducts(result.records);
        setHasMore(result.hasMore);
        setLoading(false);
      }
    }

    loadProducts();

    return () => {
      mounted = false;
    };
  }, []);

  async function viewMore() {
    setLoadingMore(true);
    const result = await appContext.getAllProducts({
      limit: PAGE_SIZE,
      offset: products.length,
      withMeta: true,
    });

    setProducts((current) => [...current, ...result.records]);
    setHasMore(result.hasMore);
    setLoadingMore(false);
  }

  function viewCatalog(product) {
    appContext.navTo({
      item: "products",
      subItem: "catalog",
      extraItem: product.uuid,
    });
  }

  return (
    <>
      <section className="products-page-hero">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6" data-aos="fade-up">
              <p className="home-banner-kicker">Products</p>
              <h1 className="products-page-title font-bold">
                Creative Work Made to Be Seen, Remembered, and Shared.
              </h1>
              <p className="products-page-copy">
                Explore practical branding options for businesses, events, and
                everyday customer touchpoints.
              </p>
              <button
                type="button"
                className="products-page-btn"
                onClick={() => appContext.navTo({ item: "contact_us" })}
              >
                Request a Quote
                <MdArrowForward size={22} />
              </button>
            </div>

            <div className="col-lg-6" data-aos="fade-left">
              <img
                src={packageImage}
                alt="Esmeriser branded packaging"
                className="products-page-hero-img"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="products-page-grid-section">
        <div className="container">
          <div className="products-page-heading">
            <p className="home-banner-kicker">What You Can Order</p>
            <h2 className="home-service-title font-bold">Available Products</h2>
          </div>

          {loading ? (
            <div className="mSupportLoading" style={{ minHeight: 320 }}>
              {getInlineLoader()}
            </div>
          ) : products.length > 0 ? (
            <>
              <div className="products-page-grid">
                {products.map((product) => (
                  <article
                    className="products-page-card"
                    key={product.uuid || product.id}
                    role="button"
                    tabIndex={0}
                    onClick={() => viewCatalog(product)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        viewCatalog(product);
                      }
                    }}
                  >
                    <div className="products-page-card-media">
                      <img
                        src={
                          product.photo
                            ? CDN_URL + product.photo
                            : fallbackImage
                        }
                        alt={product.title || "Esmeriser product"}
                      />
                    </div>
                    <div className="products-page-card-body">
                      <h3 className="font-bold">
                        {product.title || "Esmeriser Product"}
                      </h3>
                      <p>
                        {product.description ||
                          "A branded product available from Esmeriser."}
                      </p>
                      <span className="products-page-card-link">
                        View Catalog
                        <MdArrowForward size={18} />
                      </span>
                    </div>
                  </article>
                ))}
              </div>

              {hasMore ? (
                <div className="page-view-more-row">
                  <button
                    type="button"
                    className="page-view-more-btn"
                    onClick={viewMore}
                    disabled={loadingMore}
                  >
                    {loadingMore ? "Loading..." : "View More"}
                    <MdExpandMore size={22} />
                  </button>
                </div>
              ) : null}
            </>
          ) : (
            <div className="home-empty-state">
              <h3 className="font-bold">Products are coming soon.</h3>
              <p>Published products from the admin panel will appear here.</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
}
